import AbstractView from 'abstract';
import Vue from 'vue'
import store from 'definitions/store'

export class Main extends AbstractView {
    constructor(domElementId) {
        return super(domElementId);
    }

    init() {
        const Terms = () => import(/* webpackChunkName: "snippet-items-terms" */ 'components/SnippetTemplate/Items/Terms')
        new Vue({
            el: "#" + this.elemId,
            store,
            render: h => h(Terms, {props: eval(this.elemId)})
        })
    }
}
